(() => {
  const data = document.getElementById('MixedAquariumBoxPricing');
  const productId = data?.dataset?.productId || "6947567829073";
  const productHandle = data?.dataset?.productHandle || "mixed-box-of-aquarium-plants";
  const root = document.querySelector(`.ae-pdp[data-product-id="${productId}"]`);
  if (!data || !root) return;
  const variants = JSON.parse(data.textContent);
  const desktop = window.matchMedia('(min-width: 990px)');
  const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  const count = value => Number(value.match(/\((\d+) pots\)/)?.[1]);
  const sellingPrice = (variant, plan) => {
    if (!plan) return variant.price;
    return variant.plans.find(item => String(item.id) === plan)?.price;
  };
  let queued = false;
  const update = () => {
    queued = false;
    const sizes = root.querySelectorAll('select[name="options[Size]"]');
    if (!desktop.matches) {
      root.querySelectorAll('[data-mixed-box-per-pot]').forEach(item => item.remove());
      sizes.forEach(select => Array.from(select.options).forEach(option => {
        if (option.textContent.trim() !== option.value) option.textContent = option.value;
      }));
      return;
    }
    const info = root.querySelector('.product__info-container');
    const form = info?.querySelector('product-form form[action*="/cart/add"]');
    const plan = form?.querySelector('[name="selling_plan"]')?.value || '';
    const style = info?.querySelector('select[name="options[Style]"]')?.value || null;
    const size = info?.querySelector('select[name="options[Size]"]')?.value;
    const selected = variants.find(item => item.style === style && item.size === size);
    sizes.forEach(select => Array.from(select.options).forEach(option => {
      const variant = variants.find(item => item.style === style && item.size === option.value);
      const price = variant && sellingPrice(variant, plan);
      const pots = count(option.value);
      const text = price != null && pots ? `${option.value} · ${money.format(price / 100 / pots)} each` : option.value;
      if (option.textContent.trim() !== text) option.textContent = text;
    }));
    const price = selected && sellingPrice(selected, plan);
    const pots = selected && count(selected.size);
    const priceBlock = info?.querySelector('[id^="price-"]');
    if (!priceBlock || price == null || !pots) return;
    let summary = priceBlock.querySelector('[data-mixed-box-per-pot]');
    if (!summary) {
      summary = document.createElement('p');
      summary.dataset.mixedBoxPerPot = '';
      summary.setAttribute('aria-live', 'polite');
      summary.style.cssText = 'margin:4px 0 0;font-size:14px;line-height:1.4;font-weight:400;color:#4b4b49';
      priceBlock.append(summary);
    }
    const text = `Box of ${pots} pots · ${money.format(price / 100 / pots)} each`;
    if (summary.textContent !== text) summary.textContent = text;
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  root.addEventListener('change', () => {
    schedule();
    setTimeout(schedule, 150);
    setTimeout(schedule, 500);
  });
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
  desktop.addEventListener('change', schedule);
  const storageKey = 'ae-mixed-box-price-refresh' + (productId === '6947567829073' ? '' : '-' + productId);
  const productForms = () => Array.from(document.querySelectorAll('product-form form[action*="/cart/add"]')).filter(form => variants.some(variant => String(variant.id) === form.querySelector('[name="id"]')?.value));
  const fingerprint = items => JSON.stringify(items.map(item => [String(item.id), item.price, item.plans.map(plan => [String(plan.id), plan.price]).sort()]).sort());
  const initialPrices = fingerprint(variants);
  const showMessage = (form, text) => {
    let message = form.querySelector('[data-mixed-box-price-message]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.mixedBoxPriceMessage = '';
      message.setAttribute('role', 'status');
      message.style.cssText = 'font-size:14px;line-height:1.4;margin:8px 0';
      form.querySelector('[type="submit"]')?.before(message);
    }
    if (message.textContent !== text) message.textContent = text;
  };
  const selectedForm = () => productForms().find(form => form.getBoundingClientRect().width > 0) || productForms()[0];
  const reloadPrices = form => {
    form = form || selectedForm();
    const variant = form?.querySelector('[name="id"]')?.value;
    const plan = form?.querySelector('[name="selling_plan"]')?.value || '';
    const quantity = form?.querySelector('[name="quantity"]')?.value || '1';
    try { sessionStorage.setItem(storageKey, JSON.stringify({ variant, plan, quantity })); } catch (_) {}
    const url = new URL(location.href);
    if (variant) url.searchParams.set('variant', variant);
    if (plan) url.searchParams.set('selling_plan', plan);
    else url.searchParams.delete('selling_plan');
    url.searchParams.set('_ae_price_refresh', Date.now());
    location.replace(url.href);
  };
  let inFlight;
  const checkPrices = () => {
    if (inFlight) return inFlight;
    const url = new URL((window.Shopify?.routes?.root || '/') + 'products/' + productHandle + '.js', location.origin);
    url.searchParams.set('_ae_price_check', Date.now());
    inFlight = fetch(url, { cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(8000) })
      .then(response => {
        if (!response.ok) throw new Error('Price check unavailable');
        return response.json();
      })
      .then(product => {
        if (String(product.id) !== productId || !Array.isArray(product.variants)) throw new Error('Price check unavailable');
        const current = product.variants.map(variant => ({ id: variant.id, price: variant.price, plans: (variant.selling_plan_allocations || []).map(allocation => ({ id: allocation.selling_plan_id, price: allocation.price })) }));
        return fingerprint(current) !== initialPrices;
      })
      .finally(() => { inFlight = null; });
    return inFlight;
  };
  const refreshIfChanged = () => {
    if (document.visibilityState !== 'visible') return;
    checkPrices().then(changed => { if (changed) reloadPrices(); }).catch(() => {});
  };
  let restore;
  try { restore = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
  let restoringPlan = Boolean(restore?.plan);
  if (restore) {
    const deadline = Date.now() + 30000;
    const restoreSelection = () => {
      const form = selectedForm();
      if (!form || form.querySelector('[name="id"]')?.value !== restore.variant) return false;
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity) quantity.value = restore.quantity;
      showMessage(form, 'Prices have been updated. Please review your total before adding to cart.');
      if (restore.plan) {
        const interval = form.querySelector('select[name="subs_interval"]');
        const option = form.querySelector('.sls-option-container[data-selling-plan-group]');
        if (!interval || !option || !Array.from(interval.options).some(item => item.value === restore.plan)) return false;
        if (form.querySelector('[name="selling_plan"]')?.value !== restore.plan) {
          interval.value = restore.plan;
          interval.dispatchEvent(new Event('change', { bubbles: true }));
          if (!option.classList.contains('sls-active')) option.click();
        }
        if (form.querySelector('[name="selling_plan"]')?.value !== restore.plan) return false;
      }
      restoringPlan = false;
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      schedule();
      return true;
    };
    const retryRestore = () => {
      if (restoreSelection()) return;
      if (Date.now() < deadline) setTimeout(retryRestore, 250);
      else {
        const form = selectedForm();
        if (form) showMessage(form, 'Your purchase option is still loading. Please refresh the page and try again.');
      }
    };
    setTimeout(retryRestore, 250);
  }
  const permitted = new WeakSet();
  const pending = new WeakSet();
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!productForms().includes(form)) return;
    if (permitted.has(form)) { permitted.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (restoringPlan) {
      showMessage(form, 'Restoring your subscription selection. Please try again in a moment.');
      return;
    }
    if (pending.has(form)) return;
    pending.add(form);
    const submitter = event.submitter;
    checkPrices().then(changed => {
      if (changed) { reloadPrices(form); return; }
      form.querySelector('[data-mixed-box-price-message]')?.remove();
      permitted.add(form);
      form.requestSubmit(submitter?.isConnected ? submitter : undefined);
    }).catch(() => showMessage(form, 'We couldn’t confirm the current price. Please try again.'))
      .finally(() => pending.delete(form));
  }, true);
  window.addEventListener('focus', refreshIfChanged);
  window.addEventListener('pageshow', refreshIfChanged);
  document.addEventListener('visibilitychange', refreshIfChanged);
  setInterval(refreshIfChanged, 60000);
  refreshIfChanged();
  update();
})();
